module.exports = __webpack_public_path__ + "static/media/profile.a5607c03.jpg";